var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"35","cy":"35","r":"32","stroke":"white","strokeWidth":"6","key":0}),React.createElement("path",{"d":"M24.6416 33.947C23.7298 32.5636 21.8692 32.1813 20.4858 33.093C19.1024 34.0048 18.7201 35.8654 19.6318 37.2489L24.6416 33.947ZM30.8119 48.7603L28.3071 50.4112L30.9218 54.3784L33.3794 50.3121L30.8119 48.7603ZM49.8324 23.0899C50.6894 21.6719 50.2347 19.8276 48.8167 18.9706C47.3987 18.1136 45.5545 18.5683 44.6974 19.9863L49.8324 23.0899ZM19.6318 37.2489L28.3071 50.4112L33.3168 47.1094L24.6416 33.947L19.6318 37.2489ZM33.3794 50.3121L49.8324 23.0899L44.6974 19.9863L28.2444 47.2085L33.3794 50.3121Z","fill":"white","key":1})]);
}

Success.defaultProps = {"width":"70","height":"70","viewBox":"0 0 70 70","fill":"none"};

module.exports = Success;

Success.default = Success;
